import {
  Directive,
  Input,
  ViewContainerRef,
  ComponentRef,
  OnInit, HostListener, Injector
} from '@angular/core';
import { ModelActionsComponent } from './model-actions.component';
import { ModelFormDialogComponent } from './form-dialog/model-form-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DemoDialogComponent } from '../pages/ui/components/components-overview/components/components-overview-dialogs/components-overview-dialogs.component';
import { CategoriesService } from '../pages/categories/categories.service';
import { MODEL_CONFIG } from './form-dialog/model-config';



@Directive({
  standalone: true,
  selector: '[appModelActions]'
})
export class ModelActionsDirective implements OnInit {
  @Input('appModelActions') modelType!: string;
  @Input() id?: any;
  @Input() data?: any;
  @Input() action?: string;
  @Input() initData!: { key: string, value: any }[];

  private selectedService: any;

  constructor(private vcr: ViewContainerRef, private dialog: MatDialog, private categoryService: CategoriesService, private injector: Injector,) {}

  @HostListener('click')
  onClick() {
    switch (this.action) {
      case 'add':
        this.openCreateForm();
        break;
      default:
        console.warn(`Unknown action: ${this.action}`);
    }
  }


  ngOnInit(): void {
    const compRef: ComponentRef<ModelActionsComponent> =
      this.vcr.createComponent(ModelActionsComponent);

    const config = MODEL_CONFIG[this.modelType];
    const serviceClass = config.service;
    this.selectedService = this.injector.get(serviceClass);

    compRef.instance.modelType = this.modelType;
    compRef.instance.id = this.id;
    compRef.instance.action = this.action;

    compRef.instance.add.subscribe(() => this.openCreateForm());
    compRef.instance.update.subscribe(() => this.openUpdateDialog());
    compRef.instance.remove.subscribe(() => this.openRemoveDialog());
  }

  private openCreateForm() {
    this.dialog.open(ModelFormDialogComponent, {
      data: { modelType: this.modelType, action: 'add', initData: this.initData }
    });
  }

  private openUpdateDialog() {
    console.log(`Update ${this.modelType} (id=${this.id})`);
    this.dialog.open(ModelFormDialogComponent, {
      data: {
        modelType: this.modelType,
        action: 'update',
        model: this.data,
        initData: this.initData
      }
    });
  }

  private openRemoveDialog() {
    console.log(`Remove ${this.modelType} (id=${this.id})`);

    const dialogRef = this.dialog.open(DemoDialogComponent, {});

    dialogRef.afterClosed().subscribe((confirmed: string) => {
      if (confirmed=="Yes") {
        this.selectedService.delete(this.id).subscribe({
          next: (res: any) => {
            console.log('Deleted successfully', res);
          },
          error: (err:any) => {
            console.error('Delete failed', err);
          },
        });
      } else {
        console.log('Delete canceled');
      }
    });
  }
}
